import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import { isEmpty, uniqueId } from 'lodash';
import moment from 'moment';
import { styled } from '@mui/system';
import { convertMoney } from '@/utils/convertMoney';
import { style } from '@/styles/globals';
import { StyledTableRow } from '@/components/StyledTableRow';
import WideTableCell from '@/components/WideTableCell';
import FlexTableRow from '@/components/FlexTableRow';
import { Box } from '@mui/material';
import { pr } from '@/utils/pxToRem';
import ShowNoDataDescription from '@/components/ShowNoDataDescription';

const CTABooking = styled('div')`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color:${style.color.product3};
  cursor: pointer;
`;

export default function TableFare({
  flightData, selectedDate, onSelectTrip,
}: any) {
  const date = moment(selectedDate).format('YYYY-MM-DD');
  const data = flightData ? flightData[date] : [];

  return (
    <TableContainer
      component={Paper}
      sx={{
        minHeight: '50px',
        boxShadow: 'none',
      }}
    >
      <Table
        sx={{ }}
        aria-label="simple table"
      >
        <TableHead>
          <FlexTableRow sx={{ background: 'white' }}>
            <WideTableCell
              align="center"
            >
              Khởi hành
            </WideTableCell>
            <WideTableCell
              align="center"
            >
              Giá thấp nhất
            </WideTableCell>
            <WideTableCell
              sx={{ whiteSpace: 'nowrap' }}
              align="center"
            />
          </FlexTableRow>
        </TableHead>
        <TableBody>
          {!isEmpty(data) ? data?.slice(0, 4)?.map((row: any) => (
            <StyledTableRow
              key={uniqueId()}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <WideTableCell align="center">{row.pickup_time}</WideTableCell>
              <WideTableCell align="center">{convertMoney(row.total_price_adult)}</WideTableCell>
              <WideTableCell align="center">
                <CTABooking onClick={() => onSelectTrip(row)}>
                  Đặt vé
                </CTABooking>
              </WideTableCell>
            </StyledTableRow>
          )) : <Box sx={{ p: pr`16px` }}><ShowNoDataDescription /></Box>}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
